import React, { useState } from 'react';

import jet from "@randajan/jet-core";
import { Block } from "@randajan/jet-react/dom/block";
import { Pane } from "@randajan/jet-react/dom/pane";
import { Range, Switch, Field, Form } from "@randajan/jet-react/dom/form";

import { page } from "../../config/base";
import { Currency } from '../../elements/Currency/Currency';

import "./Calculator.scss";
import { usePromise } from '@randajan/jet-react';

import { PagePop } from '../../elements/PagePop/PagePop';
import { Apiform } from '../../elements/Apiform/Apiform';

import { map } from '@randajan/jet-core/eachSync';
import { bifrost } from '../../config/bifrost';


const clang = {
    labels: {
        detailed: "Podrobné nastavení",
        acc: "Počet uživatelů",
        pc: "Počet terminálů",
        netgear: "Počet síťových prvků",
        gear: "Počet periferií",
        server: "Počet serverů",
        service: "Počet sdílených služeb",
        services_user: "Počet uživatelů sdílených služeb",
        workday: "Pracovní dny",
        weekend: "Víkendy a svátky",
        labor: "Běžný servis do",
        urgent: "Urgentní servis do"
    }
}

const rawput = {
    acc: 1,
    pc: 1,
    netgear: 0,
    gear: 0,
    server: 0,
    service: 0,
    services_user: 0,
    workday: 1,
    weekend: 0,
    labor: 48,
    urgent: 8
}

const temp = {
    range: [" - ", "9:00 - 17:00", "6:00 - 22:00", "Nonstop"]
}

function countprice(input, f) {
    let { detailed, acc, pc, netgear, gear, server, service, services_user, workday, weekend, labor, urgent } = input

    let scope = 0, range = 0, speed = 0;

    pc = detailed ? pc : acc;
    netgear = detailed ? netgear : 0;
    gear = detailed ? gear : 0;
    service = detailed ? service : server;
    services_user = (detailed ? services_user : acc) * service;

    scope += acc * f["7vF5WPJR"]?.price_czk; //vedení uživatelského účtu
    scope += pc * f["7PZg1dOw"]?.price_czk; //Správa terminálu
    scope += netgear * f["SFSx7nSx"]?.price_czk //Správa aktivního síťového prvku
    scope += gear * f["tP4MRivu"]?.price_czk; //Správa periferie
    scope += server * f["6txFpgoA"]?.price_czk; //Správa serveru
    scope += service * f["iLEDHZcz"]?.price_czk; //Správa sdílené služby
    scope += services_user * f["yrufuTUM"]?.price_czk; //Příplatek za vedení uživatele sdílené služby
    

    range = workday + weekend - 1;
    speed += 4 - Number.jet.whatpow(labor / 3, 2);
    speed += 3 - Number.jet.whatpow(urgent, 2);

    scope = Math.round(scope);
    range = Math.round(range * scope * .25); //constant rate
    speed = Math.round(speed * scope * .25); //constant rate

    let full = scope + range + speed;

    return { scope, range, speed, full };
}

export const Calculator = () => {
    const [pageSearch] = page.use("search");

    const output = pageSearch.get();
    const input = jet.full(output, rawput);

    const { result:features, status } = usePromise({}, async _ => {
        const features = await bifrost.tx("sunListFeatures");
        const result = {};
        if (Array.isArray(features)) {
            features.forEach(row => { result[row.id] = row; });
        }
        return result;
    }, []);

    const price = status === "done" ? countprice(input, features) : {};

    const propsForm = {
        labels: clang.labels, className: "grid", rawput, output,
        onInput: form => pageSearch.set("", map(form.getInput(), v => Number.jet.to(v)))
    }

    return (
        <section className="Calculator" data-status={status}>
            <Block level={0} className="block wall" caption={"Kalkulačka externích IT služeb"}>
                <Form {...propsForm}>
                    <Block className="flex scope" caption={"Rozsah vašeho IT systému"}>
                        <Switch name="detailed" vertical />
                        <Field name="acc" type="number" />
                        <Pane expand={!!input.detailed} transition={600}>
                            <Field name="pc" type="number" />
                            <Field name="netgear" type="number" />
                            <Field name="gear" type="number" />
                        </Pane>
                        <Field name="server" type="number" />
                        <Pane expand={!!(input.detailed && input.server > 0)} transition={600}>
                            <Field name="service" type="number" />
                            <Field name="services_user" type="number" />
                        </Pane>
                        <div className="price">
                            <Currency value={price.scope} />
                        </div>
                    </Block>

                    <Block className="flex range" caption={"Kdy nás potřebujete?"}>
                        <div className="grid">
                            <Range name="workday" from={0} to={3} min={1} step={1} />
                            <span className="value">{temp.range[input.workday]}</span>
                            <Range name="weekend" from={0} to={3} step={1} />
                            <span className="value">{temp.range[input.weekend]}</span>
                        </div>
                        <div className="price">
                            <span>+</span>
                            <Currency value={price.range}/>
                        </div>
                    </Block>

                    <Block className="flex speed" caption={"Rychlost naší reakce"}>
                        <div className="grid">
                            <Range name="labor" from={48} to={12} step={12} />
                            <span className="value">{input.labor} hodin</span>
                            <Range name="urgent" from={8} to={2} step={2} />
                            <span className="value">{input.urgent} hodin</span>
                        </div>
                        <div className="price">
                            <span>+</span>
                            <Currency value={price.speed} />
                        </div>
                    </Block>

                </Form>
                <div className="fullprice">
                    <span>Měsíční plnění</span>
                    <Currency value={price.full} />
                    <span className="novat">bez DPH</span>
                </div>
                <div className="nextstep">
                    <PagePop caption={"Odeslat poptávku"} hash={"chat"}>
                        <Apiform name={"chat"} caption={"Napište nám!"} rawput={{src:page.get("href")}} afterDone={_=>page.remove("hash.chat")}>
                            <Block caption="Děkujeme!">
                                <p>Vaši poptávku jsme zaznamenali</p>
                                <p>Věnovat se vám budeme hned jak to bude možné</p>
                            </Block>
                        </Apiform>
                    </PagePop>
                </div>
            </Block>
        </section>
    )
}


export default Calculator;